import { fromJS, Map } from 'immutable';
import {
  openNavMenu,
  closeNavMenu,
  toggleNavMenu,
  toggleAccountMenu,
  toggleNavigationMain,
  toggleHideDefaultTopNavigation
} from './actions';

export const defaultState = Map({
  isMenuOpen: false,
  isAccountMenuOpen: false,
  navigationOpen: true,
  hideDefaultTopNavigation: false
});

export default function navigation(state = defaultState, action) {
  const newState = fromJS(state);

  switch (action.type) {
    case openNavMenu.type:
      return newState.set('isMenuOpen', true);

    case closeNavMenu.type:
      return newState.set('isMenuOpen', false);

    case toggleNavMenu.type:
      return newState.set('isMenuOpen', !newState.get('isMenuOpen'));

    case toggleAccountMenu.type:
      return newState.set('isAccountMenuOpen', !newState.get('isAccountMenuOpen'));

    case toggleNavigationMain.type:
      return newState.set('navigationOpen', !newState.get('navigationOpen'));

    case toggleHideDefaultTopNavigation.type: {
      const usePayload = typeof action.payload === 'boolean';

      return newState.set(
        'hideDefaultTopNavigation',
        usePayload ? action.payload : !newState.get('hideDefaultTopNavigation')
      );
    }

    default:
      return newState;
  }
}

export const selectIsMenuOpen = state => state.navigation.get('isMenuOpen');
export const selectIsAccountMenuOpen = state => state.navigation.get('isAccountMenuOpen');
export const isLoggedIn = state => state.auth.get('userToken') !== null;
export const selectNavigationOpen = state => state.navigation.get('navigationOpen');
export const hideDefaultTopNavigation = state => state.navigation.get('hideDefaultTopNavigation');
